import React from "react";
import type { BlockFragment } from "../../../../core/generated/webapi.g";
import { FeedResultFragment } from "../../../../core/generated/webapi.g";
import { isFeedResult } from "../../../../core/lib/guards";
import { FeedDisplayHints, getCoastHints } from "../../../../core/services/Sites.utils";
import { HeadingProps } from "../../../../core/ui/Heading.component";
import { CoastFeed } from "../../components/feed/CoastFeed.component";
import { CoastCarousel } from "../carousel/CoastCarousel.component";

interface DatasourceProps {
    content: FeedResultFragment[] | null;
    block: BlockFragment;
    feedId: string;
    displayHints: FeedDisplayHints;
    title: string;
    heading?: HeadingProps;
}

export class Datasource extends React.Component<DatasourceProps> {
    constructor(props: DatasourceProps) {
        super(props);
    }

    render() {
        const { title, content, block } = this.props;

        // check hints here and throw it to appropriate component
        const hints = getCoastHints(block.tags);
        if (hints?.includes("coast-carousel")) {
            if (content && isFeedResult(content[0])) {
                return <CoastCarousel content={content} />;
            }
            // not a valid feed, so return null
            return null;
        }

        return <CoastFeed block={block} title={title} content={content} />;
    }
}
